export default {"src":"/_next/static/media/merge_account_icon.b88d9aff.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};